import { OtpVerifyViewModel } from '@apis/model/mfa/OtpVerifyViewModel';
import { OtpVerifyResponse } from '@ul/api';

export const toOtpVerifyViewModel = (otpVerifyResponse: OtpVerifyResponse): OtpVerifyViewModel => {
    const { success, responseCode, otpType, solved, token, memberId, otpClaims } = otpVerifyResponse;
    return {
        success,
        responseCode,
        otpType,
        solved,
        token,
        memberId,
        otpClaims,
    };
};
